/* eslint-disable import/no-anonymous-default-export */
import axios from './axios';

const URL = process.env.REACT_APP_API_URL;

const mapAccount = (account) => {

  account.accountType = account.type;

  return account;
}

export default {
  async getAccounts(params) {
    const { items, total } = await axios.get(`${URL}/api/v1/accounts`, { params });

    items.forEach(x => mapAccount(x));

    return { items, total }
  },
  async createAccount(params) {
    return mapAccount(await axios.post(`${URL}/api/v1/accounts`, params));
  },
  async updateAccount(id, params) {
    return mapAccount(await axios.put(`${URL}/api/v1/accounts/${id}`, params));
  },
  deleteAccount(id) {
    return axios.delete(`${URL}/api/v1/accounts/${id}`);
  },
  getAuditLogs(params) {
    return axios.get(`${URL}/api/v1/audit-logs`, { params });
  },
  async getAccount(id) {
    const account = await axios.get(`${URL}/api/v1/accounts/${id}`);

    mapAccount(account);

    return account;
  },
};
